import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../Generic/Button";
import Card from "../../Generic/Card";
import InputBox from "../../Generic/InputBox";
import SuccessButton from "../../Generic/SuccessButton";
import CookBookConnector from "../Connector/CookBookConnector";
import { successNotification, errorNotification } from "../../Generic/Notifications";
import { RecipeSegmentsEdit } from "./RecipeSegmentsEdit";
import { SearchBarWithResults } from "./SearchBarWithResults";
import StudioService from "../Services/StudioService";
import { useNavigate } from "react-router-dom";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem;
`;


const Header = styled.div`
	display: flex;
	justify-content: flex-start;
	font-size: 1.6rem;
	margin: ${(props) => props.margin};
	width: 100%;
`;

const Div = styled.div`
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	gap: ${(props) => props.gap};
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const RecipeCreate = (props) => {
	const { objectToEdit } = props;
	const navigate = useNavigate();

	async function sendUpdatedData() {
		var payload = {
			...props.payload,

			//Hardcoded things which need to be taken as an input later on.
			brandId: "kocafe",
		}
		const response = await StudioService.createRecipe(payload);
		const { data, error } = response;
		if (data) {
			successNotification("Changes saved successfully");
			navigate(`/studio/recipe/${data._id}`);
		}
		if (error) {
			errorNotification(error);
		}
	}

	function updateData(evnt) {
		//Get numeric input for fields if type is set as number
		var payload =
			evnt.target.type == "number"
				? { column: evnt.target.id, value: evnt.target.valueAsNumber }
				: { column: evnt.target.id, value: evnt.target.value };
		if (evnt.target.type === "checkbox") {
			payload = { column: evnt.target.id, value: evnt.target.checked };
		}
		props.updateRecipe(payload);
	}

	useEffect(() => {
		return () => {
			//Edit mode can be ignored ,just to clear objectToEdit and payload
			props.changeEditMode({ objectToEdit: {} });
		};
	}, []);

	function renderRecipeCreate(recipe) {
		return (
			<>
				<Card margin="1rem 0 0 0" width="100%" alignItem="center" flexDirection="column">
					<Div flexWrap="wrap" flexDirection="row" width="100%" alignItem="center" gap="1rem" >
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Name</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"name"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.name}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Description</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"description"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.description}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Note</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"note"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.note}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div flexDirection="row" jContent="" alignItem="center">
							<Div flexDirection="column" jContent="" alignItem="">
								<Div color="rgba(0,0,0,0.6)">Preparation Time</Div>
								<Div width="100%" margin="0.5rem 0 0 0">
									<InputBox
										type="number"
										id={"preparationTime"}
										onChange={(e) => {
											updateData(e);
										}}
										value={recipe?.preparationTime}
										padding="0.5rem"
										width="10rem"
									/>
								</Div>
							</Div>
						</Div>
						<Div width="100%" margin="0 0 1rem 0" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Dish</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<SearchBarWithResults
									colToShow="title"
									colToStore="_id"
									endpoint="/v1/dashboard/dishes/search?page=1&"
									onChange={(val) => {
										props.updateRecipe({ column: "dishId", value: val });
									}}
								/>
							</Div>
						</Div>
					</Div>
				</Card>
				<RecipeSegmentsEdit needMixing={recipe?.needMixing} Patterns={props.Patterns} updatePayload={props.updateRecipe} />
				<Div jContent="flex-end" margin="1rem 0 0 0">
					<Div margin="0.5rem" onClick={() => {}}>
						<Button onClick={() => props.changeEditMode({ objectToEdit: {} })}>Reset</Button>
					</Div>
					<Div margin="0.5rem">
						<SuccessButton
							onClick={() => {
								sendUpdatedData();
							}}>
							Confirm
						</SuccessButton>
					</Div>
				</Div>
			</>
		);
	}

	return (
		<Page>
			<Div width="100%" alignItem="center">
				<Header margin="0 0 0 0.5rem">Create Recipe</Header>
			</Div>
			{renderRecipeCreate(objectToEdit)}
		</Page>
	);
};

export default CookBookConnector(RecipeCreate);
